import { render, staticRenderFns } from "./material-analysis-table.vue?vue&type=template&id=18883890&scoped=true"
import script from "./material-analysis-table.vue?vue&type=script&setup=true&lang=js"
export * from "./material-analysis-table.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18883890",
  null
  
)

export default component.exports